<script setup lang="ts">
const form = useForm({
	method: 'POST',
	url: route('password.email'),
	fields: {
		email: '',
	},
})
const status = useProperty<string | null>('status')
</script>


					<script lang="ts">
					import __hybridly_layout_0 from '~/resources/layouts/security.vue';
					export default { layout: [__hybridly_layout_0] }
					</script>
					<template>
				
	<ui-card-content>
		<ui-alert v-if="status" class="mb-4" variant="informative">
			{{ status }}
		</ui-alert>

		<ui-form @submit.prevent="form.submit">
			<ui-form-item>
				<ui-label for="email">
					{{ t('validation.attributes.email') }}
				</ui-label>
				<ui-input
					id="email"
					v-model="form.fields.email"
					required
					autofocus
					autocapitalize="off"
					autocomplete="username"
					autocorrect="off"
					type="email"
				/>
				<ui-form-error :message="form.errors.email" />
			</ui-form-item>

			<ui-button type="submit" :loading="form.processing">
				{{ t('app.buttons.send_password_reset_link') }}
				<template #icon>
					<i-ph-arrow-right />
				</template>
			</ui-button>
		</ui-form>
	</ui-card-content>

	<ui-card-footer :class="cn('rounded-b-none sm:rounded-b-xl', $attrs.class ?? '')">
		<div class="flex w-full items-center justify-center gap-1 text-sm text-gray-500">
			<span>{{ t('app.remember_your_password_again') }}</span>
			<ui-link :href="route('login')">
				{{ t('app.buttons.sign_in') }}
			</ui-link>
		</div>
	</ui-card-footer>
</template>
